// extracted by mini-css-extract-plugin
export default {"transferInfoItem":"transferInfoItem___uzRJl","label":"label___jRVh0","value":"value___Tgfc9","value_light":"value_light___NUkk9","copy":"copy___hGXs1"};